module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/address/postcode.js
// module id = 1928
// module chunks = 0